export const PLATFORM = 'web';
